module.exports = "/_next/static/images/e3fd1e95e6c4aee1e0f72a1dcbee5138-roxinho-details-metalico-xs@3x.jpg";